var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.93066L23.5 8.93066",
    stroke: "#4C4C4C",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87891 5.75862V1H10.0168V5.75862H2.87891Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87891 16.8621V12.1035H10.0168V16.8621H2.87891Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9824 5.75862V1H21.1204V5.75862H13.9824Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9824 16.8621V12.1035H21.1204V16.8621H13.9824Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.2ca912ec8d732a2733c69928b80a4f2f.svg";
export { ForwardRef as ReactComponent };